module.exports = __webpack_public_path__ + "img/HealthcareMC.f90b80bd.svg";